<template>
  <div class="checkbox-container-row"
       :class="{ 'checkbox-container-row-bordered': container }">
    <div class="custom-checkbox">
      <input v-if="submitUnchecked" type="hidden" :name="name" :value="uncheckedValue">
      <input
        :id="id"
        type="checkbox"
        :name="name"
        :disabled="disabled"
        v-model="model"
        :value="submittedValue"
        class="custom-checkbox-input">
      <label
        :for="id"
        class="custom-checkbox-label">
        <span v-if="humanizeText" class="custom-checkbox-label-text">
          {{ label || name | humanize }}
        </span>
        <span v-else class="custom-checkbox-label-text">
          {{ label || name }}
        </span>
        <span v-if="status">{{ status }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";

export default {
  name: "CheckBox",

  mixins: [
    UIComponentMixin
  ],

  props: {
    name: { type: String },
    label: { type: String },
    status: { type: String },
    submittedValue: { type: [Boolean, String, Number] },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    value: { type: [Array, Boolean] },
    humanizeText: { type: Boolean, default: true },
    uncheckedValue: { type: [Boolean, String, Number], default: null },
    submitUnchecked: { type: [Boolean], default: true },
    container: { type: Boolean, default: false }
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  }
};
</script>
